import * as z from "zod";

import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";

export const fixedJobConfigSchema = z.object({
  amount: z
    .number({
      required_error: REQUIRED_MESSAGE,
      invalid_type_error: "Amount must be a number",
    })
    .min(0, "Amount must be in positive or 0"),
  currency: z
    .string({
      required_error: REQUIRED_MESSAGE,
    })
    .min(1, "Currency cannot be empty"),
});
